import request from "@/api/request";

export var verifyInvitationCode = (code) => request.get(`/register/verifyInvitationCode?code=${code}`)

export var register = (registerApplyInfo) => request.post('/register', registerApplyInfo)

export var searchResident = (search,communityId) => request.get(`/register/search?communityId=${communityId}&search=${search}`)

export var sendVerifyCode = (phone, templateId, belongId) => request.get(`/register/sendVerifyCode?phone=${phone}&templateId=${templateId}&belongId=${belongId}`)